export const UK_LOGGED_OUT_GROUPTOKEN = '0010'
export const GLASGOW_LOGGED_IN_GROUPTOKEN = '0071'
export const OUT_OF_REGION_LOGGED_IN_GROUPTOKEN = '0021'
export const EU_REGION_CODE = '8'
export const DEFAULT_GROUPTOKEN = GLASGOW_LOGGED_IN_GROUPTOKEN
export const SET_USER_DATA = 'SET_USER_DATA'
export const CLEAR_USER_DATA = 'CLEAR_USER_DATA'
export const ADD_CLASS_NAME = 'ADD_CLASS_NAME'
export const FETCH_LOGIN_ENABLED_SUCCESS = 'FETCH_LOGIN_ENABLED_SUCCESS'
export const FETCH_LOGIN_ENABLED_FAILURE = 'SET_LOGIN_ENABLED_FAILURE'
export const FETCH_PS_ENABLED_SUCCESS = 'FETCH_PS_ENABLED_SUCCESS'
export const FETCH_PS_ENABLED_FAILURE = 'FETCH_PS_ENABLED_FAILURE'
export const INVALID_TOKEN = 'INVALID_TOKEN'
export const GEOBLOCKED = 'GEOBLOCKED'
export const NOT_FOUND = 'NOT_FOUND'
export const NOT_AVAILABLE = 'NOT_AVAILABLE'
export const NOT_LOGGED_IN = 'NOT_LOGGED_IN'
export const POSTCODE_REQUIRED = 'POSTCODE_REQUIRED'
export const PLAYER_API_REQUEST = 'PLAYER_API_REQUEST'
export const PLAYER_API_RECEIVE = 'PLAYER_API_RECEIVE'
export const GUIDANCE_TEXT = 'GUIDANCE_TEXT'
export const STOP_RESUME_FOUND = 'STOP_RESUME_FOUND'
export const SET_GUIDANCE_ACCEPTED = 'SET_GUIDANCE_ACCEPTED'
export const SET_PIN_ACCEPTED = 'SET_PIN_ACCEPTED'
export const SET_PIN = 'SET_PIN'
export const CLEAR_PIN = 'CLEAR_PIN'
export const SET_STOP_RESUME_POSITION = 'SET_STOP_RESUME_POSITION'
export const CLEAR_STOP_RESUME_POSITION = 'CLEAR_STOP_RESUME_POSITION'
export const STOP_RESUME_START_FROM_BEGINNING = 'STOP_RESUME_START_FROM_BEGINNING'
export const STOP_RESUME_START_FROM_SR_POSITION = 'STOP_RESUME_START_FROM_SR_POSITION'
export const LIVE_RESTART_EVENT = 'LIVE_RESTART_EVENT'
export const LIVE_SKIP_EVENT = 'LIVE_SKIP_EVENT'
export const LIVE_RESUME_EVENT = 'LIVE_RESUME_EVENT'
export const LIVE_RESTART_ERROR = 'LIVE_RESTART_ERROR'
export const LIVE_STREAM_ERROR = 'LIVE_STREAM_ERROR'
export const PREVIEW_PLAYER_ERROR = 'PREVIEW_PLAYER_ERROR'
export const RESTART_DISABLED_STREAM_DIALOG = 'RESTART_DISABLED_STREAM_DIALOG'
export const RESTART_STREAM_DIALOG = 'RESTART_STREAM_DIALOG'
export const RESTART_STREAM_END = 'RESTART_STREAM_END'
export const PLAYER_HAS_STARTED = 'PLAYER_HAS_STARTED'
export const PLAYER_STREAM_END = 'PLAYER_STREAM_END'
export const PLAYER_RESTART_STREAM_HAS_STARTED = 'PLAYER_RESTART_STREAM_HAS_STARTED'
export const PIN_CHECK = 'PIN_CHECK'
export const UPDATE_LIVE_PLAYER_PROPS = 'UPDATE_LIVE_PLAYER_PROPS'
export const UPDATE_PREVIEW_PLAYER_PROPS = 'UPDATE_PREVIEW_PLAYER_PROPS'
export const UNKNOWN_ERROR = 'UNKNOWN_ERROR'
export const UPDATE_PROGRAMME_METADATA = 'UPDATE_PROGRAMME_METADATA'
export const ENDBOARD_DURATION = 15000
export const CLEARCACHE_KEY = '83edb09ff31e7366cb623731b679376e'
export const CONVIVA_CUST_KEY_TEST = 'd651fcb32625f8e6cb49bcf2786b1c7c1bf81f44'
export const CONVIVA_CUST_KEY_PROD = '9826ee735b7b2164f30bfa9458b091d48a1f426c'
export const CONTINUE_WATCHING_COUNT = 4
export const SERVER_ERROR = 'SERVER_ERROR'
export const TIMED_OUT = 'TIMED_OUT'
export const GUIDANCE_ACCEPTED = 'GUIDANCE_ACCEPTED'
export const SET_PLAYER_ERROR = 'SET_PLAYER_ERROR'
export const SET_COOKIE_POLICY_ACCEPTED = 'SET_COOKIE_POLICY_ACCEPTED'
export const SET_TOGGLE_STATE = 'SET_TOGGLE_STATE'
export const SET_HIDE_SPONSOR = 'SET_HIDE_SPONSOR'
export const SET_API_ERROR = 'SET_API_ERROR'
export const CLEAR_API_ERROR = 'CLEAR_API_ERROR'
export const SET_EPISODE_DATA = 'SET_EPISODE_DATA'
export const SET_NEXT_EPISODE_DATA = 'SET_NEXT_EPISODE_DATA'
export const SET_CURRENT_EPISODE = 'SET_CURRENT_EPISODE'

export const SET_RECOMMENDED_PROGRAMME = 'SET_RECOMMENDED_PROGRAMME'

export const PERSONALISED_HERO_SLIDES = 0
export const FEATURE_LIVE_SCRUB_SKIP_BUTTON = true
export const WAYS_TO_WATCH_INDICATOR = true

export const VOD_AUTOPLAY_ENABLED = 1

export const STV_COOKIES = {
  STV_STOP_RESUME_COOKIE: 'STV_RESUME',
  STV_USERID: 'STV_USERID',
  STV_GROUPTOKEN: 'STV_GROUPTOKEN',
  STV_UNREGISTERED_GROUPTOKEN: 'STV_UNREGISTERED_GROUPTOKEN',
  STVPLAYER_CONTROLS: 'STVPLAYER_CONTROLS',
  STVPLAYER_RESET: 'STVPLAYER_RESET',
  STV_AUTH_REQUIRED: 'STV_AUTH_REQUIRED',
  STV_PERSONALISATION_OPTIN: 'STV_PERSONALISATION_OPTIN',
  STV_PLAYER_PLUS: 'STV_PLAYER_PLUS',
  STV_VIP_OPTIN: 'STV_VIP_OPTIN',
  STV_ALERT_COOKIE: 'STV_ALERT_COOKIE',
}

export const PLAYER_ERROR_CODES_MAP = {
  10: INVALID_TOKEN, // invalid Token
  14: NOT_FOUND, // not-found
  15: NOT_AVAILABLE, // expired or not yet available
  23: NOT_LOGGED_IN, // geolocation-required
  24: NOT_LOGGED_IN, // not-in-area
  26: NOT_LOGGED_IN, // requires-login
  30: NOT_LOGGED_IN, // requires-login
  31: POSTCODE_REQUIRED, // requires-data-capture
  32: POSTCODE_REQUIRED, // geolocation-required
  33: NOT_LOGGED_IN, // requires-login
  34: GEOBLOCKED, // not-found
  35: GEOBLOCKED, // geoblocked
  /*
    player error code 403 is only returned for users in the EU trying to access
    content that is unavailable to them.
    Note this is different from HTTP status 403 which is returned at other times
    but with a player-specific error response.
  */
  404: NOT_FOUND,
  408: TIMED_OUT,
  500: SERVER_ERROR,
}

export const VOD_MESSAGE_TYPES = {
  CONTENT_HAS_ENDED: 'VOD:CONTENT_HAS_ENDED',
  PLAYING: 'VOD:PLAYING',
  MUTED: 'VOD:MUTED',
  STOPPED: 'VOD:STOPPED',
  STOP_RESUME_SAVE_REQUEST: 'VOD:STOP_RESUME_SAVE_REQUEST',
  PLAYER_ERROR: 'VOD:PLAYER_ERROR',
  SHOW_ENDBOARD: 'VOD:SHOW_ENDBOARD',
  PAUSED: 'VOD:PAUSED',
  UNPAUSED: 'VOD:UNPAUSED',
  STARTED: 'VOD:STARTED',
}

export const CARD_RENDITIONS = ['225x127', '365x205', '460x259', '512x289']

export const POSTER_RENDITIONS = ['225x381', '460x613']

export const GUIDE_CARD_RENDITIONS = CARD_RENDITIONS

export const MOBILE_GUIDE_CARD_RENDITIONS = POSTER_RENDITIONS

export const LOGO_RENDITIONS = ['100x100']

export const FEATURED_EVENTS = {
  // exporting an object so Jest can mock the slugs array
  slugs: ['rugby-world-2019'],
}

export const SWIFTYPE_CLIENT_KEY = 'zF2GWeuhKvasLuSWzyea'

export const SET_CHANNELS = 'SET_CHANNELS'

export const SEND_PS_HEADER = true
